import 'nested-worker/window.js';
import 'bootstrap/dist/css/bootstrap.css';
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.css';
import 'datatables.net-select-bs4/css/select.bootstrap4.css';
import 'datatables.net-fixedheader-bs4/css/fixedHeader.bootstrap4.css';

import 'datatables.net-searchpanes-bs4/css/searchPanes.bootstrap4.css';

import './style.scss';

import $ from 'jquery';

// require datatables without invoking or passing arguments to make it work with webpack
import 'bootstrap';
import 'datatables.net';
import 'datatables.net-bs4';

// Buttons
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons-bs4';

// Header
import 'datatables.net-fixedheader';

// Search Panes
import 'datatables.net-select'; // Searchpanes requires select
import 'datatables.net-searchpanes';
//import 'datatables.net-searchpanes-bs4';
import './searchpanes.bootstrap4';
import { canMarkDelivered, canSeeCustomerDetails, canSeeOwnOrders } from '../private/permissions.js';

let user = {};
const reload_table = window.reload_table = (checkServer) => {
  if (window.table) {
    if (checkServer) {
      checkLastUpdated = true;
    }

    window.table.$('tr').css('opacity', 0.3);
    window.table.ajax.reload();
  }
}

const state = {
  include_virtual: 0,
  setState: function (key, value) {
    if (this[key] === value) {
      return;
    }

    this[key] = value;

    // Update DOM
    if (this.include_virtual) {
      $('.include-virtual').addClass('active');

    } else {
      $('.include-virtual').removeClass('active');

    }

    reload_table(true);

  }
};

const currentUserCanMarkDelivered = () => {
  return canMarkDelivered(user.userRole);
};

const currentUserCanSeeCustomerDetails = () => {
  return canSeeCustomerDetails(user.userRole);
};

const currentUserCanSeeOwnOrders = () => {
  return canSeeOwnOrders(user.userRole) || currentUserCanSeeCustomerDetails();
};

const render_bool = function (data, type) {
  if (type === 'display') {
    return data ? 'Yes' : 'No';
  }
  return data;
};

const getButton = (action, label, btnStyle='btn-link', rowAction=false) => {
  if (rowAction) {

    const { confirmMsg, onSuccess} = rowAction;
    $('#datatable').on('click', `.${action}`, function (e) {
      e.preventDefault();
      const $this = $(this);
      const tr = $this.closest('tr');
      const row = window.table.row(tr).data();
      const sku = row['SKU'];
      if (confirmMsg && !confirm(confirmMsg.replace('{sku}', sku))) {
        return;
      }
      $this.addClass('btn-loading').attr("disabled", true);
      const cancel = _ => $this.removeClass('btn-loading').attr("disabled", false);
      $.ajax('/api/row-action', {
        data: JSON.stringify({ sku, action, row }),
        contentType: 'application/json',
        type: 'POST',
      })
        .then(function (response) {
          if (response.status === 'success') {
            onSuccess({ $this, tr, row, sku });
          } else {
            alert(response.error);
            cancel();
          }
        })
        .fail(function () {
          cancel();
        });
    });
  }

  return `<a href="#" class="btn ${btnStyle} btn-loading-overlay ${action}"><span class="spinner"><span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span></span><span class="btn-inner-text">${label}</span></a>`;
};

const buttons = {
  createOrder: '<a href="#" class="btn btn-secondary btn-loading-overlay create-order"><span class="spinner"><span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span></span><span class="btn-inner-text">Add to Quote</span></a>',
  markDelivered: getButton('mark_delivered', 'Mark Delivered', 'btn-info', {
    confirmMsg: 'This will mark item {sku} as delivered and remove it from the stock list.',
    onSuccess: ({ $this, tr }) => {
      tr.addClass('delivered');
      $this.parent().html('<span class="badge badge-success">Marked as Delivered</span>');
      tr.find('td.condition').text('Delivered');
    }
  }),
  releaseStock: getButton('release_stock', '<i class="icon-unlock"></i> Release Stock', 'btn-link', {
    confirmMsg: 'This will release item {sku} to be available to order.',
    onSuccess: ({ $this }) => {
      $this.parent().html(buttons.createOrder + buttons.unreleaseStock + '<br /><span class="badge badge-success">Released</span>');
    }
  }),
  unreleaseStock: getButton('unrelease_stock', 'Unrelease Stock', 'btn-link', {
    confirmMsg: 'This will unrelease item {sku} to be available to order.',
    onSuccess: ({ $this }) => {
      $this.parent().html(buttons.releaseStock + '<br /><span class="badge badge-success">Unreleased</span>');
    }
  }),
  requestRelease: getButton('request_release', 'Request Release', 'btn-link', {
    confirmMsg: 'This will request the release of item {sku}.',
    onSuccess: ({ $this }) => {
      $this.parent().html('<span class="badge badge-success">Requested for Release</span>');
    }
  }),
};

const render_date = (data, type) => {
  if ('0000-00-00' === data) {
    return '';
  }
  if (type !== 'display') {
    return data;
  }

  if ('2999-12-31' === data) {
    return 'TBC';
  }

  try {
    const date = data.split('-');
    if (date.length === 3) {
      date.reverse();
      return date.join('-');
    }

  } catch (e) { }

  return '';
};

// https://gist.github.com/mathewbyrne/1280286
function slugify(text) {
  return text.toString().toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}

// Set vars on the window
const logo = __LOGO__ ? __LOGO__ : 'logo.png';
$('.logo').attr('src', 'assets/' + logo);

$('.open-cpanel').attr('href', __SITE__ + '_cpanel/');
$('title, .title').text(`${__SITENAME__} Stock Manager`);

// Check if we have a login session
$.get('/api/login').then(res => {
  if (res.redirect) {
    window.location.href = res.redirect;
    return;
  }

  user = res.user;

  $('body').css('opacity', 1);

  // Draw the table
  startStockManager();

  // Pass the current customer to the context
  // TODO - Should we do this the other way around?
  typeof (window.StockManagerContext) !== 'undefined' && window.StockManagerContext.setCurrentUser(user);

  // Enable the Keap features if allowed
  if (currentUserCanSeeCustomerDetails()) {

    $('.d-admin').removeClass('d-admin');

    // Just in case some elements with d-admin are still added via AJAX
    $('head').append('<style id="show-admin" type="text/css">.d-admin {display: block !important;}</style>')
  }

  // Enable the Keap features if allowed
  if (currentUserCanSeeOwnOrders()) {

    $('.d-orders').removeClass('d-orders');

    // Just in case some elements with d-orders are still added via AJAX
    $('head').append('<style id="show-admin" type="text/css">.d-orders {display: block !important;}</style>')
  }


});

const heldByOtherUser = (row) =>row['StockHold'] && row['StockHold'].email !== user.email;
const isAvailable = (row) => (parseInt(row['AvailableSellQuantity']) > 0 || row['Virtual'] === 'True');

const doNotSell = [
  'Sold',
  'Damaged',
  'Damaged IT',
  'Finance Hold',
  'Floor',
  'Floor IT',
  'Inventory Hold',
  'QA Hold',
  'QA Hold IT',
  'Second',
  'Second IT',
  'Show Stock',
  'Show Stock IT',
  'Used',
  'Used IT',
  'Delivered',
  'In Transfer',
  'Unappraised'
];

const isSellable = (row) => (
  doNotSell.indexOf(row['Condition']) === -1 || row['Clearance'] || row['StockRelease']
) && isAvailable(row) && !heldByOtherUser(row);

const canReleaseStock = (row) => row['Condition'] !== 'Inventory Hold' && isAvailable(row);

const render_button_col = (data, type, row) => {

  if (type === 'export') {
    return data ? [data, row['OrderID']].join(' - ') : '';
  }

  if (type === 'filter') {
    // Include all the metadata
    return [row['OrderID'], data].join(' ');
  }

  const outButtons = [];
  const skuIsAvailable = isAvailable(row);

  // If is deliverable, add delivery button
  const is_deliverable = !skuIsAvailable && row['Condition'] !== 'Delivered';

  if (is_deliverable && currentUserCanMarkDelivered()) {
    outButtons.push(buttons.markDelivered);
  }

  // Only show order button if product isn't actually in stock
  if (data && !skuIsAvailable) {
    outButtons.push(`<a href="#" class="btn btn-success"><span class="btn-inner-text">${data}</span></a>`);
  }

  // And if the product is sellable
  if (isSellable(row)) {
    outButtons.push(buttons.createOrder);

    // Is this product released?
    if (row['StockRelease']) {
      const { email, dateTimeInSydney } = row['StockRelease'];
      // Show the release time for all users
      outButtons.push(`<span title="Released by ${email} on ${dateTimeInSydney}"><svg height="30" fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM288 224C288 206.3 302.3 192 320 192C337.7 192 352 206.3 352 224C352 241.7 337.7 256 320 256C302.3 256 288 241.7 288 224zM280 288L328 288C341.3 288 352 298.7 352 312L352 400L360 400C373.3 400 384 410.7 384 424C384 437.3 373.3 448 360 448L280 448C266.7 448 256 437.3 256 424C256 410.7 266.7 400 280 400L304 400L304 336L280 336C266.7 336 256 325.3 256 312C256 298.7 266.7 288 280 288z"/></svg></span>`);

      // Show unrelease button for users who can mark delivered
      if (currentUserCanMarkDelivered()) {
        outButtons.push(buttons.unreleaseStock);
      }

    }

  } else if (canReleaseStock(row) && !row['StockHold']) {
    // If the user has the right permissions, show the release stock button.
    // TODO - Allow admin user to release HELD items, too
    outButtons.push(currentUserCanMarkDelivered() ? buttons.releaseStock : buttons.requestRelease);
  }

  if (row['StockHold']) {
    const { email, dateTimeInSydney } = row['StockHold'];
    outButtons.push(`<small class="held-msg">Held by ${email} on ${dateTimeInSydney}</small>`);
  }

  return outButtons.join('');
}

const columns = [
  {
    "className": 'details-control d-orders',
    "orderable": false,
    "data": null,
    "defaultContent": ''
  },
  { title: "Serial Number", data: 'SKU' },
  { title: "SKU", data: 'AccountingCode' },
  { title: "Model", data: 'Model', searchPanes:{ show: true }  },
  { title: "Name", data: 'Name', searchPanes:{ show: true }  },
  { title: "Shell Colour", data: 'ShellColour', searchPanes:{ show: true }  },
  { title: "Cabinet Colour", data: 'CabinetColour', searchPanes:{ show: true }  },
  { title: __KEAP_ENV__ === 'SWNZ' ? "Suburb" : "City", data: 'City', visible: false, searchPanes:{ show: true }  },
  { title: __KEAP_ENV__ === 'SWNZ' ? "City" : "State", data: 'State', visible: false, searchPanes:{ show: true }  },
  { title: "Postcode", data: 'Postcode', visible: false, searchPanes:{ show: true }  },
  { title: "Condition", data: 'Condition', className: 'condition', searchPanes:{ show: true }  },
  { title: "Status", data: 'Status', searchPanes:{ show: true } },
  { title: "Location", data: 'Location', searchPanes:{ show: true }  }, // default warehouse
  {
    title: "Stock on Hand", data: 'AvailableSellQuantity', render: (data, type, row) => {
      if (type !== 'display') {
        return data;
      }
      return parseInt(data) > 0 ? data : 0;
    }, searchPanes: { show: false }
  },
  { title: "Date Available", data: 'DateArrival', render: render_date, searchPanes:{ show: true } },
  {
    title: "SOH Age", data: 'StockAge', render: (data, type, row) => {
      if (type !== 'display') {
        return data;
      }

      if (row['Condition'] === 'Floor' || row['Condition'] === 'Floor IT') {
        return data;
      }

      const age = parseInt(data);
      if (!age) {
        return data;
      }

      const badges = [
        'success',
        'light',
        'warning',
        'danger'
      ];

      let badge = age < 60 ? badges[0] : age < 120 ? badges[1] : age < 180 ? badges[2] : badges[3];
      return `<span class="badge badge-${badge}">${data}</span>`;

    }, searchPanes: { show: false, data: "Stockage" }
  },
  //{ title: "Estimated Delivery", data: 'Misc29', render: render_date },
  {
    title: "Container", className: 'nowrap', data: 'Container', render: (data, type, row) => {
      if (type !== 'display') {
        return data;
      }
      if (!data || !__ENABLE_SHIPPING_INFO__) {
        return data;
      }

      return data + '<a class="btn btn-light mt-1 btn-block btn-sm show-shipping" data-container="' + data + '" href="#">View</a>';
    }, searchPanes: { show: false }
  },
  //{ title: "Date Ordered", data: 'Misc28', render: render_date },
  { title: "Is On Special", data: 'Specials', render: render_bool },
  { title: "Is On Clearance", data: 'Clearance', render: render_bool, className: 'clearance-col' },
  {
    title: "",
    data: "OrderID",
    orderable: false,
    searchPanes: { show: false },
    className: 'button-col',
    render: render_button_col
  }
].filter(_ => !_['title'] || !(__EXCLUDE_COLS__ || '').split(',').includes(_['title']));

const productsWorker = new Worker('productsWorker.js');
const productsWorkerCbs = {
  datatable: false,
  products: false
};

const getProducts = (cb) => {
  productsWorkerCbs['products'] = cb
  productsWorker.postMessage({ type: 'getProducts' });
};

let checkLastUpdated = false;
const $progress = $('#dt-loading .progress-bar');

productsWorker.onmessage = e => {
  let message = e.data;

  switch (message.type) {
    case 'redirect':
      window.location.href = message.data;
      break;

    case 'alert':
      alert(message.data);
      break;

    case 'progress':
      if ( !productsWorkerCbs['datatable'] ) {
        break;
      }

      $('#swau-loader').show();

      // Start at 30%
      var progress = Math.ceil((message.data) * 0.7 + 30);
      $progress.css('width', progress + '%');
      $progress.text(progress + '%');
      break;

    case 'datatable':
      if ( !productsWorkerCbs['datatable'] ) {
        break;
      }

      // RESET PROGRESS
      $('#swau-loader').hide();
      $progress.css('width', '0%');
      $progress.text('0%');

      // SEND PRODUCTS TO TABLE
      productsWorkerCbs['datatable'](message.data);
      productsWorkerCbs['datatable'] = false;
      break;

    case 'products':
      // Do nothing
      if (productsWorkerCbs['products']) {
        productsWorkerCbs['products'](message.data)
        productsWorkerCbs['products'] = false;
      }
  }

};

let searchPanesEnabled = false;

const startStockManager = async function () {

  const table = window.table = $('#datatable').DataTable({

    deferRender: true,
    fixedHeader: true,
    pageLength: 25,
    lengthMenu: [
      [10, 25, 50, -1],
      [10, 25, 50, 'All'],
    ],
    searchPanes: {
      emptyMessage: "</i></b>EMPTY</b></i>",
      layout: 'columns-6',
      cascadePanes: true,
    },
    //processing: true,
    dom:
      "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 text-right col-md-6'B>>" +
      "<'row'<'col-sm-12'tr>>" +
      "<'row mb-2'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
    buttons: {
      // Hack - not sure why BS4 defaults are not automatically applied..
      dom: $.fn.dataTable.Buttons.defaults.dom,
      buttons: [
      {
        extend: 'csv',
        text: 'Export CSV',
        exportOptions: { orthogonal: 'export' }
      },
      'colvis'
    ]
  },
    serverSide: true,
    ajax: (data, callback, settings) => {
      (async () => {
        data['searchPanesEnabled'] = searchPanesEnabled;
        productsWorkerCbs['datatable'] = callback;
        productsWorker.postMessage({
          role: user.userRole,
          data,
          checkLastUpdated,
          include_virtual: state.include_virtual
        });

        checkLastUpdated = false;
      })()
    },
    columnDefs:[{
      searchPanes:{
          show: false,
      },
      targets: '_all',
  }],
    columns,
    "order": [[1, 'asc']],

    // Add row classes
    createdRow: function (row, data, index) {
      const classes = data['Categories'] || [];

      classes.push(isAvailable(data) ? 'Available' : 'Sold');
      classes.push(data['Virtual'] === 'True' ? 'Virtual' : 'Serialized');

      data['Condition'] && classes.push(data['Condition']);

      row.classList = [...row.classList, ...classes.map(slugify)].join(' ');

    }
  });

  table.searchPanes.container().appendTo($('#searchpanes'));

  //
  $('#searchpane-container').on('show.bs.collapse', _ => {
    searchPanesEnabled = true;
    reload_table();

  });
  $('#searchpane-container').on('hide.bs.collapse', _ => {
    searchPanesEnabled = false;
    reload_table();
  });

  // Scroll to Top
  table.on('page', function () {
    setTimeout(function () {
      //$(document).scrollTop($(table.table().container()).offset().top);
      $("html, body").animate({ scrollTop: $(table.table().container()).offset().top }, 200);
    }, 10);
  });

  //
  // CHILD ROWS
  //

  const render_child_table = (columns, childRowData) => {
    const spinner = '<div class="placeholder-loading" role="status"><div></div></div>';

    let ret = '<table style="padding-left:50px;" class="table table-striped table-bordered table-child-row">';

    columns.forEach((col, i) => {
      /// Skip rendering if orderdata is not available yet.
      if (!childRowData) {
        ret += '<tr><th style="white-space: pre">' + col.title + '</th><td width="100%">' + spinner + '</td></tr>';
        return;
      }

      let data = col.data && childRowData && childRowData[col.data] ? childRowData[col.data] : '';

      if (col.renderer) {
        data = col.renderer(data);
      }

      ret += '<tr><th style="white-space: pre">' + col.title + '</th><td width="100%">' + data + '</td></tr>';
    })
    ret += '</table>';

    return ret;
  }

  function format_product_subrow(row) {
    //const spinner = '<div class="spinner-border text-primary spinner-border" role="status"></div>';

    const _render_table = (orderData) => {
      const columns = [
        { title: "Internal Product Notes", data: 'AvailabilityDescription' },
        { title: "SO#", data: 'OrderID', renderer: _ => _ ? `<a href="#" class="btn btn-success"><span class="btn-inner-text">${_}</span></a>` : _ },
        { title: "Order Status", data: 'OrderStatus' },
        { title: "Customer Name", data: 'CustomerName' },
        { title: "Internal Order Notes", data: 'InternalOrderNotes' },
      ];

      return render_child_table(columns, orderData);
    }

    var div = $('<div/>');

    div.append(_render_table());

    $.get('/api/product?sku=' + row.SKU).then(json => {
      div.html(_render_table(json));
    });

    return div;

  }

  function format_shipping_subrow(row) {

    const _render_table = (data) => {
      const columns = [
        { title: 'Shipment ID', data: 'SHIPMENT ID' },
        { title: 'Customer PO / Container ID', data: 'CUSTOMER PO / CONTAINER ID' },
        { title: 'Container Num', data: 'CONTAINER NUM' },
        { title: 'Supplier', data: 'SUPPLIER' },
        //{ title: 'Ready Date', data: 'READY DATE' },
        { title: 'Process Type', data: 'PROCESS TYPE' },
        { title: 'Origin', data: 'ORIGIN' },
        { title: 'Destination', data: 'DESTINATION' },
        { title: 'Pre-carrying Vessel/Aircraft', data: 'PRE-CARRYING VESSEL/AIRCRAFT' },
        { title: 'Mother Vessel/Aircraft', data: 'MOTHER VESSEL/AIRCRAFT' },
        { title: 'ETD', data: 'ETD' },
        { title: 'PORT ETA', data: 'PORT ETA' },
        { title: 'Container Size', data: 'CONTAINER SIZE' },
        { title: 'Status', data: 'STATUS' },
        { title: 'LAST UPDATE', data: 'LAST UPDATE' },
        //{ title: 'Detention Date', data: 'Detention Date' },
        //{ title: 'CHECKED ONLINE STOCK DATE', data: 'CHECKED ONLINE STOCK DATE' },
        { title: 'Notes', data: __KEAP_ENV__ === 'SWNZ' ? 'FIELD17' : 'FIELD18' },
      ];

      return render_child_table(columns, data);
    }

    var div = $('<div/>');

    div.append(_render_table());

    $.get('/api/get-shipping-info?container=' + row.Container).then(json => {
      div.html(_render_table(json['shipment'] ? json['shipment'] : { 'Shipment ID': 'No shipment information available.' }));
    });

    return div;

  }

  // Add event listener for opening and closing details
  const toggleChildRow = (el, type, cb) => {
    var tr = $(el).closest('tr');
    var row = table.row(tr);

    if (tr.hasClass('shown-' + type)) {
      row.child.hide();
      tr.removeClass('shown-' + type);
    } else {
      row.child(cb(row.data())).show();

      // Remove other "shown" classes
      const shownClasses = tr.attr('class').match(/\bshown-\w*/);
      if (shownClasses) {
        shownClasses.forEach(cls => tr.removeClass(cls));

      }

      tr.addClass('shown-' + type);
    }

  }

  $('#datatable tbody').on('click', '.serialized td.details-control', function () {
    toggleChildRow(this, 'details', format_product_subrow);
  });

  // Add event listener for opening and closing shipping
  $('#datatable tbody').on('click', '.show-shipping', function (e) {
    e.preventDefault();
    toggleChildRow(this, 'shipping', format_shipping_subrow);
  });

  //
  // SEARCH
  //
  $("#table-search").on('keyup change', function () {
    table.search($(this).val(), true).draw();
  });

  //
  // Toggle virtual products
  //
  $('.include-virtual').on('click', function (e) {
    e.preventDefault();

    // Toggle the state
    state.setState('include_virtual', state.include_virtual ? 0 : 1);
  });

  //
  // Reload button
  //
  $('.reload-table').on('click', function (e) {
    e.preventDefault();
    reload_table(true);
  });

  //
  // CREATE ORDER
  //
  async function hasOlderStock(selectedRows, threshold=4) {
    return new Promise((resolve, reject) => {

      // Check if there's older stock
      getProducts(products => {
        console.log('Checking for older stock...');

        // for each sku
        const hasOlderStock = selectedRows.filter(row => {

          // Only process serialised item
          if (row['AccountingCode'] == row['SKU']) {
            return false;
          }

          const stockAge = row['StockAge']||0;
          // Find other stock of the same serialised item
          const sameAs = products.filter(_ =>
            // Is sellable
            isSellable(_) &&
            // Same product
            _.AccountingCode === row.AccountingCode &&
            // In the same condition
            _.Condition == row.Condition &&
            // In the same warehouse
            _.WarehouseReference == row.WarehouseReference
          );
          console.log('Found', sameAs.length, 'of', row.AccountingCode, sameAs);

          const olderStock = sameAs.filter(_ => _.StockAge > stockAge);
          console.log('Older stock:', olderStock);

          if (olderStock.length > (threshold-1)) {
            return true;
          }

          return false;
        });

        if (hasOlderStock.length) {
          return reject(hasOlderStock);
        }

        return resolve();

      });
    });
  }

  $('#datatable').on('click', '.create-order, .create-quote', async function (e) {
    e.preventDefault();

    const $this = $(this);
    const tr = $this.closest('tr');
    const row = table.row(tr);
    const rowData = row.data();

    try {
      await hasOlderStock(Object.values([rowData]), 4);

    } catch (e) {
      const olderStockMsg = e.map(row => `- ${row['SKU']} (${row['AccountingCode']})`).join('\n');
      alert(`There is older stock of these items:\n${olderStockMsg}\n\nPlease use the older stock first.`);
      return;
    }

    const product = {
      sku: rowData['SKU'],
      accountingCode: rowData['AccountingCode'],
      warehouseCode: rowData['WarehouseReference'],
      enableQty: rowData['Virtual'] === 'True' || rowData['SKU'] === rowData['AccountingCode'],
      condition: rowData['Condition'],
      name: rowData['Name'],
      model: rowData['Model'],
      price: parseFloat(rowData['RRP'])||parseFloat(rowData['DefaultPrice'])||0,
    }

    window.OrderButtons.addToOrder(product);

  });


};
